import * as yup from "yup";

export const schema = yup.object().shape({
  passengers: yup.string().required("Required"),
  isFreeTicket: yup.boolean().required("Required"),
  serviceName: yup.string().required("Required"),
  location: yup
    .object()
    .shape({
      id: yup.string().required("Required"),
      nameEn: yup.string(),
    })
    .required("Required"),
});

export interface FormInputs extends yup.InferType<typeof schema> {}

export function formatServicePriceLabel(
  service: Record<string, any> | null | undefined,
): string | null {
  if (!service) {
    return null;
  }

  switch (String(service.pricingType ?? "")) {
    case "free":
      return "free";
    case "fixed":
      return formatPriceAmount(service.fixedPrice);
    case "custom": {
      const price = formatPriceAmount(service.customPrice);
      if (price == null) {
        return null;
      }
      const hours = Number(service.customStartHrs);
      if (!Number.isFinite(hours) || hours <= 0) {
        return price;
      }
      return `first ${hours} ${hours === 1 ? "hour" : "hours"} ${price}`;
    }
    case "hourly": {
      const price = formatPriceAmount(service.hourlyPrice);
      return price == null ? null : `${price} per hour`;
    }
    case "daily": {
      const price = formatPriceAmount(service.dailyPrice);
      return price == null ? null : `${price} per day`;
    }
    default:
      return formatPriceAmount(service.fixedPrice ?? service.customPrice);
  }
}

function formatPriceAmount(value: unknown): string | null {
  const amount = Number(value);
  return Number.isFinite(amount) && amount >= 0 ? String(amount) : null;
}

export const getAddressFromCoordinates = async (
  lat: number,
  lng: number,
  language = "en",
): Promise<string> => {
  const response = await fetch(
    `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&language=${language}&key=${process.env.REACT_APP_GOOGLE_MAPS_API_KEY}`,
  );

  const data = await response.json();

  if (data.status !== "OK") {
    throw new Error(data.status);
  }

  return data.results[0]?.formatted_address ?? "";
};
